import { GroundPositionState, GroundPositionType } from "src/models/GroundPosition";

export function translateGroundPositionType(type) {
  switch (type) {
    case GroundPositionType.DOCK:
      return 'Doca';
    case GroundPositionType.STREET:
      return 'Rua';
    case GroundPositionType.QUALITY_CONTROL:
      return 'Controle de qualidade';
    case GroundPositionType.STOCK:
      return 'Estoque';
    case GroundPositionType.EXPEDITION:
      return 'Expedição';
    case GroundPositionType.DIVERGENT_STOCK:
      return 'Estoque Divergente';
    case GroundPositionType.DAMAGES:
      return 'Danos';
    case GroundPositionType.PICKING:
      return 'Separação';
    case GroundPositionType.PROVISION:
      return 'Provisão';
    case GroundPositionType.IN:
      return 'Entrada';
    case GroundPositionType.EXIT:
      return 'Saída';
    case GroundPositionType.PICKING_MISCELLANEOUS:
      return 'Separação Multi Produtos';
    case GroundPositionType.PIGEONHOLE:
      return 'Escaninho';
    default:
      return type || '---';
  }
}

export function translateGroundPositionState(state) {
  switch (state) {
    case GroundPositionState.READY:
      return 'Pronto';
    case GroundPositionState.MARKED_TO_REPLACE_RFID:
      return 'Marcado para troca de tag RFID';
    case GroundPositionState.NO_STATE:
      return 'Sem estado';
    case GroundPositionState.BLOCKED:
      return 'Bloqueado';
    case GroundPositionState.LAYOUTING:
      return 'Posicionando';
    case GroundPositionState.MARKED_TO_REPLACE_QR_CODE:
      return 'Marcado para troca de QR Code';
    default:
      return state || '---';
  }
}